import React, { useState } from 'react';
import Widget from '../Widget';
import WidgetTitle from '../WidgetTitle';

export default function ElectiveClassifications({ institutionData }) {

    const cce = institutionData.post_meta.cce.value > 0;
    const lpp = institutionData.post_meta.lpp.value > 0;

    if (!cce && !lpp) return null;

    return (
        <Widget className="institutional-classification background-white">
            <div className="row" style={{ minHeight: '180px' }}>
                <div className='d-flex justify-content-center p-3'>
                    {cce && (
                        <img src='/wp-content/plugins/ace-carnegie-institution-charts/frontend/src/images/community-badge.png' alt="Community Engagement Elective Badge" />
                    )}
                    {lpp && (
                        <img src='/wp-content/plugins/ace-carnegie-institution-charts/frontend/src/images/leadership-badge.png' alt="Leadership for Public Purpose Elective Badge" />
                    )}
                </div>
            </div>
            <div className="row border-top pt-3 px-3">
                <div className="col-9">
                    <WidgetTitle>Elective Classifications</WidgetTitle>
                </div>
                <div className="col-3">

                </div>
            </div>
            <div className="row px-3">
                <div className="col-12">
                    {cce && (
                        <a href="/elective-classifications/community-engagement/" target="_blank" rel="noopener noreferrer">Community Engagement &gt;</a>
                    )}
                    {cce && lpp &&
                        <br />
                    }
                    {lpp && (
                        <a href="/elective-classifications/leadership-about/" target="_blank" rel="noopener noreferrer">Leadership for Public Purpose &gt;</a>
                    )}
                </div>
            </div>
        </Widget>
    );
}